import api from './api';

// Get all invitation codes
const getInvitationCodes = async () => {
  const response = await api.get('/api/invitation-codes');
  return response.data;
};

// Create a new invitation code
const createInvitationCode = async (data) => {
  const response = await api.post('/api/invitation-codes', data);
  return response.data;
};

// Get all users
const getAllUsers = async () => {
  const response = await api.get('/api/admin/users');
  return response.data;
};

// Update a user's maxTimelines
const updateUserMaxTimelines = async (userId, maxTimelines) => {
  const response = await api.put(`/api/admin/users/${userId}/max-timelines`, { maxTimelines });
  return response.data;
};

// Delete a user
const deleteUser = async (userId) => {
  const response = await api.delete(`/api/admin/users/${userId}`);
  return response.data;
};

// Update user role
const updateUserRole = async (userId, roleData) => {
  const response = await api.put(`/api/admin/users/${userId}/role`, roleData);
  return response.data;
};

// Update user profile (username, email, password)
const updateUserProfile = async (userId, profileData) => {
  const response = await api.put(`/api/admin/users/${userId}/profile`, profileData);
  return response.data;
};

// Update user permissions (modules, group, editors)
const updateUserPermissions = async (userId, permData) => {
  const response = await api.put(`/api/admin/users/${userId}/permissions`, permData);
  return response.data;
};

// Create a new admin user
const createAdminUser = async (userData) => {
  const response = await api.post('/api/admin/users', userData);
  return response.data;
};

// Delete an invitation code
const deleteInvitationCode = async (codeId) => {
  const response = await api.delete(`/api/invitation-codes/${codeId}`);
  return response.data;
};

const adminService = {
  getInvitationCodes,
  createInvitationCode,
  getAllUsers,
  updateUserMaxTimelines,
  deleteUser,
  updateUserRole,
  updateUserProfile,
  updateUserPermissions,
  createAdminUser,
  deleteInvitationCode,
};

export default adminService; 